var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.422,
    height: 34.279,
    viewBox: "0 0 31.422 34.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6706",
    "data-name": "Path 6706",
    d: "M29.854,25.067,23.815,22.8A3.8,3.8,0,0,0,20.1,23.5l-1.5,1.261s-.52-.2-1.227-.522c0,0-6.711-5.258-8.226-9.846-.05-.151-.083-.3-.135-.437-.133-.453-.2-.772-.2-.772l1.481-1.278a3.761,3.761,0,0,0,1.276-3.545L10.293,2.048C7.516-3.111,1.6,3.106,1.6,3.106A12.008,12.008,0,0,0,.687,13.137c.034.185,1.8,9.628,13.356,17.526,3.3,2.6,8.04,4.871,13.356,2.823,0,0,7.081-4.857,2.456-8.4Z",
    transform: "translate(0 -0.001)",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.5b003903f9a0a7543d6f8bb6741de23b.svg";
export { ForwardRef as ReactComponent };